import { Router, ActivatedRoute, ParamMap, NavigationExtras} from '@angular/router';
import { AlertService } from '../_infrastructure/Alerts/alert.service';
import { Component, AfterViewInit, ViewChild, ElementRef, Inject, OnDestroy, OnInit, ChangeDetectorRef, DoCheck } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { SystemInformationService } from '../_infrastructure/SystemInformation/SystemInformationService';
import { SecurityService } from '../_infrastructure/Security/SecurityService';
import { SessionStorageService } from '../_infrastructure/SessionStorageService/SessionStorageService';

@Component({
    selector: 'submission-landing-page',
    templateUrl: './submission-landing-page.component.html',
    standalone: false
})

export class SubmissionLandingPageComponent implements OnInit, OnDestroy, AfterViewInit{
  
  public messageCode: string;
  public message: string;

  public forceRender: string;

  public subscriberNumber: number;
  public manifestNumber: number;
  // PIT 40803 \\
  public destinoRouter: string;

  constructor(private changeDetector: ChangeDetectorRef, private http: HttpClient, private activeRoute: ActivatedRoute, private router: Router,
    private alertService: AlertService, @Inject(DOCUMENT) private document: Document, private systemInformationService: SystemInformationService,
    private securityService: SecurityService, private sessionStorageService: SessionStorageService) {

    //const navigation = this.router.getCurrentNavigation();
    //const state = navigation.extras.state;
    const state = history.state;
    if (state) {
      this.messageCode = state.code;
      this.message = state.data;
    }
    //Isto é a coisa mais parva que eu ja fiz mas o alert não estava a aparecer, porque não era detetado como uma change ao componente
    //Muito possivelmente por utilização do lifecycle errado
    //A rever mais tarde
    setTimeout(() => {this.forceRender = this.forceRender == "a" ? "b" : "a" }, 500);
  }

  ngOnInit(): void {

    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\

    this.activeRoute.paramMap.subscribe((params: ParamMap) => {
      this.subscriberNumber = <any>params.get('subscriber');
      this.manifestNumber = <any>params.get('manifest');
      var accept = <any>params.get('accept') == "accept";

      let loggedSubscriber: number = +this.securityService.userDetails.utente?.split(' ')[0];

      if (this.subscriberNumber && this.manifestNumber) {
        if (loggedSubscriber == undefined || loggedSubscriber != this.subscriberNumber) this.handleWrongSubscriber();
        else {
          if (accept) this.validateManifest();
          else this.rejectManifest();
        }
      }
    });
  }


  //LIFECYCLE
  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    this.checkForMessage();
  }

  validateManifest() {
    this.http.post<models.WorkflowStatusVM>('api/WorkflowSearch/AcceptManifest', null, { params: { subscriberNumber: <any>this.subscriberNumber, manifest: <any>this.manifestNumber } })
      .subscribe(
        result => {
          if (result.stateCode == 'OK') {
            this.messageCode = 'OK';
            this.message = 'WorkflowSearch.AcceptManifest';
          } else {
            this.messageCode = result.stateCode;//'OK';
            this.message = result.message; //'WorkflowSearch.AcceptManifest';

          }
          
          this.checkForMessage();
        },
        error => console.error(error)
      );
  }

  rejectManifest() {
    this.http.post<models.WorkflowStatusVM>('api/WorkflowSearch/RejectManifest', null, { params: { subscriberNumber: <any>this.subscriberNumber, manifest: <any>this.manifestNumber } })
      .subscribe(
        result => {
          if (result.stateCode == 'OK') {
            this.messageCode =  'OK';
            this.message = 'WorkflowSearch.RejectManifest';
          } else {
            this.messageCode = result.stateCode;// 'OK';
            this.message = result.message; //'WorkflowSearch.RejectManifest';
          }
          this.checkForMessage();
        },
        error => console.error(error)
      );
  }

  checkForMessage() {
    switch (this.messageCode) {
      case 'OK': {
        this.alertService.success(this.message);
        break;
      }
      case 'INFO': {
        this.alertService.info(this.message); break;
      }
      default: {
        this.alertService.error(this.message);
        break;
      }
    }
  }

  handleWrongSubscriber() {
    const navigationExtras: NavigationExtras = { state: { data: 'WorkflowSearch.InvalidSubscriberManifest', code: 'ER' } };
    this.router.navigate(['workflowSearch'], navigationExtras);
  }
}
